export default __webpack_public_path__ + "static/media/melissa.2818d733.png";